import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 1.1rem;
    text-align: justify;

    div {
      text-align: center;
      h1 {
        font-weight: bold;
        font-size: 1.3rem;
        color: ${({ theme }) => theme.text};
      }
    }

    span {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.text};
    }
`;